// extracted by mini-css-extract-plugin
export default {"wrapper":"Sx-z","viewport":"Tx-z","container":"Ux-z","slide":"Vx-z"};